export default __webpack_public_path__ + "static/play_store-28fb1d94f809e484c4686f7864354823.png";